import env from './env';

export const VERSION = env.REACT_APP_VERSION;
export const APM_ACTIVATE = env.REACT_APP_APM_ACTIVATE;
export const APM_SERVICE_NAME = env.REACT_APP_APM_SERVICE_NAME;
export const APM_SERVER_URL = env.REACT_APP_APM_SERVER_URL;
